<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/zoom'
import { authComputed, siteListMethod, meetingListMethod } from '@state/helpers'
import { ZoomMtg } from '@zoomus/websdk'
ZoomMtg.checkSystemRequirements()
ZoomMtg.getWebSDKVersion()
ZoomMtg.setZoomJSLib('https://source.zoom.us/1.8.6/lib', '/av')
ZoomMtg.preLoadWasm()
ZoomMtg.prepareJssdk()

export default {
  page: {
    title: 'Start Class',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      userError: null,
      isUserError: false,
      isLoading: false,
      show: false,
      platformId: '',
      platform: '',
      collegeId: '',
      collegeName: '',
    }
  },
  computed: {
    ...authComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.fetchSiteList()
      .then((siteconfig) => {
        siteconfig.forEach((element) => {
          if (element.platform_id === this.currentUser.user.platform_id) {
            this.platformId = element.platform_id
            this.platform = element.site_name
            this.collegeId = element.platform_id
            this.collegeName = element.site_name
          }
        })

        this.getSignature()
      })
      .catch((_error) => {})
  },
  methods: {
    ...siteListMethod,
    ...meetingListMethod,

    getSignature() {
      const meetingId = this.$route.params.meetingId
      const password = this.$route.params.password
      const Data = {
        meetingId,
        role: '1',
      }
      this.generateSignature({ Data }).then((resp) => {
        const meetConfig = {
          apiKey: resp.key,
          meetingNumber: meetingId,
          leaveUrl: `${process.env.VUE_APP_APP_BASE_URL}`,
          userName: this.collegeName,
          email: this.currentUser.user.email,
          role: 1, // 1 for host; 0 for attendee
        }
        document.getElementById('zmmtg-root').style.display = 'block'

        ZoomMtg.init({
          leaveUrl: meetConfig.leaveUrl,
          isSupportAV: true,
          disableInvite: true,
          // on success, call the join method
          success: function() {
            ZoomMtg.join({
              // pass your signature response in the join method
              signature: resp.signature,
              apiKey: meetConfig.apiKey,
              meetingNumber: meetConfig.meetingNumber,
              userName: meetConfig.userName,
              userEmail: meetConfig.email,
              passWord: password,
              error(res) {},
            })
          },
        })
      })
    },
  },
}
</script>
<style>
@import url('https://source.zoom.us/1.8.6/css/bootstrap.css');
@import url('https://source.zoom.us/1.8.6/css/react-select.css');

.footer {
  height: auto !important;
}

.footer__inner .btn-default {
  background: transparent !important;
  border: 0 !important;
}
.meeting-client-inner {
  width: 100vw !important;
}
.meeting-client {
  width: 100vw !important;
}
#zmmtg-root {
  width: 100vw !important;
}

@media screen and (max-width: 767px) {
  .dropup .dropdown-menu,
  .navbar-fixed-bottom .dropdown .dropdown-menu {
    margin-left: -75px;
  }
}
</style>
<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            <b-alert
              v-model="isUserError"
              variant="danger"
              v-html="userError"
            ></b-alert>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
